import { ExistingFirmResponse } from '@api/firm/firm.types';
import { MortgageClub } from '@api/mortgage-club/mortgageClub.types';
import { Network } from '@api/network/network.types';
import { SubmissionFunnelTypeEnum } from '@pages/ApplicationFormPage/Submission/types';

export type BtlSubmissionRouteUIConfig = {
  visibleOptions: SubmissionFunnelTypeEnum[];
  selectableOptions: SubmissionFunnelTypeEnum[];
  defaultOption: SubmissionFunnelTypeEnum;
};

export function getBtlSubmissionRouteUIConfig(firm: ExistingFirmResponse): BtlSubmissionRouteUIConfig {
  const visibleOptions = [SubmissionFunnelTypeEnum.DIRECT];

  if (firm.network) {
    visibleOptions.push(SubmissionFunnelTypeEnum.NETWORK);
  }

  if (firm.mortgageClub) {
    visibleOptions.push(SubmissionFunnelTypeEnum.MORTGAGE_CLUB);
  }

  const selectableOptions = visibleOptions.length > 1 ? visibleOptions : [];

  return {
    visibleOptions,
    selectableOptions,
    defaultOption: SubmissionFunnelTypeEnum.DIRECT,
  };
}

export function isValidBtlFunnelTypeForFirm(firm: ExistingFirmResponse, funnelType: SubmissionFunnelTypeEnum): boolean {
  const config = getBtlSubmissionRouteUIConfig(firm);

  if (config.selectableOptions.length === 0) {
    return funnelType === config.defaultOption;
  }

  return config.selectableOptions.includes(funnelType);
}

export function getBtlOrganisationForFunnelType(
  firm: ExistingFirmResponse,
  funnelType: SubmissionFunnelTypeEnum,
): Network | MortgageClub | null {
  if (funnelType === SubmissionFunnelTypeEnum.NETWORK) {
    return firm.network ?? null;
  }

  if (funnelType === SubmissionFunnelTypeEnum.MORTGAGE_CLUB) {
    return firm.mortgageClub ?? null;
  }

  return null;
}
